// extracted by mini-css-extract-plugin
export var actionText = "_oo-4";
export var container = "_oo-0";
export var leftSection = "_oo-1";
export var rightSection = "_oo-2";
export var settingsButton = "_oo-6";
export var settingsIcon = "_oo-7";
export var shortcut = "_oo-5";
export var shortcutGroup = "_oo-3";